import * as autobahn from 'autobahn-browser';
import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {WsResponse, WsSendEvent} from '../_models/ws.model';

@Injectable({
  providedIn: 'root'
})
export class WsService {

  // AUTOBAHN WS
  wsAutobahn: any;
  private wsAutobahn$ = new ReplaySubject<WsResponse>(1);
  private wsAutobahnSession: any;
  readonly wsAutobahnChannel = environment.wsXbarPrefix + '.warp';

  wsInit() {
    // CONNECT
    this.wsAutobahn = new autobahn.Connection({url: environment.wsXbar, realm: 'realm1', headers: {'Authorization': btoa('none:none')}});
    this.wsAutobahn.open();

    // CONNECT EVENTS
    this.wsAutobahn.onopen = (session) => {
      // console.log('wsAutobahn opened');
      this.wsAutobahnSession = session;
      const resp = new WsResponse();
      resp.data = 'websocket connected successfully';
      resp.type = 'connected';
      session.subscribe(
        this.wsAutobahnChannel,
        (args, kwargs, details) => this.onChannelUpdate(args, kwargs, details)
      );
      this.newWsMessage(resp);
    };

    // CLOSE EVENT
    this.wsAutobahn.onclose = (e) => {
      const resp = new WsResponse();
      if (e.wasClean) {
        console.log('wsAutobahn closed');
        resp.data = 'disconnected';
        resp.type = 'disconnected';
      } else {
        console.log('wsAutobahn closed due to error');
        // CLOSE WAS TRIGGERED BY AN ERROR (WS ERROR ALWAYS CALLS WS CLOSE)
        if (this.wsAutobahn.readyState !== 1) {
          // FAILED CONNECTION
          resp.data = 'Failed to connect. Is the server running and are you connected to the internet?';
          resp.type = 'error';
        } else {
          // OTHER ERROR
          resp.data = JSON.stringify(e);
          resp.type = 'error';
        }
      }
      this.newWsMessage(resp);
    };

    // ERROR EVENT
    this.wsAutobahn.onerror = (e) => {
      // TESTING ONLY
      console.log(e);
    };

    // HARD DISCONNECT FROM BROWSER
    return () => {
      if (this.wsAutobahn) {
        this.wsAutobahn.close();
      }
    };

  }

  onChannelUpdate(args: any[], kwargs: any, details: any) {
    const data = args[0];
    const resp = new WsResponse();
    resp.type = data?.type || details.topic.replace(environment.wsXbarPrefix + '.', '');
    resp.data = data?.data || data;
    this.newWsMessage(resp);
  }

  wsSendEvent(e: WsSendEvent, excludeMe = false): void {
    if (this.wsAutobahn) {
      this.wsAutobahnSession.publish(this.wsAutobahnChannel, [e], null, {exclude_me: excludeMe});
    }
  }

  // ********************************************************************************************************
  // BROADCAST DATA
  // ********************************************************************************************************

  private newWsMessage(msg: WsResponse) {
    this.wsAutobahn$.next(msg);
  }

  onNewWsMessage(): Observable<WsResponse> {
    return this.wsAutobahn$.asObservable();
  }

}
